import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { CoreMappingsActions } from '../actions/core-mappings.actions';

@Injectable({ providedIn: 'root' })
export class CoreMappingsActionsFacade {
  private readonly _store = inject(Store);

  public loadBuyers(): void {
    this._store.dispatch(CoreMappingsActions.loadBuyers());
  }

  public uploadMappings(file: File, buyerId: string): void {
    this._store.dispatch(CoreMappingsActions.uploadMappings({ file, buyerId }));
  }

  public downloadMappings(buyerId: string, fileName: string): void {
    this._store.dispatch(
      CoreMappingsActions.downloadMappings({ buyerId, fileName }),
    );
  }

  public resetUpload(): void {
    this._store.dispatch(CoreMappingsActions.uploadMappingsReset());
  }

  public resetDownload(): void {
    this._store.dispatch(CoreMappingsActions.downloadMappingsReset());
  }
}
